export const TYPES = {
  bold: "bold",
  code: "code",
  italic: "italic",
  link: "link",
  powerWord: "powerWord",
};
